var _circle, _polygon, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _polygon2, _polygon3, _rect46, _rect47, _polygon4, _polygon5, _rect48, _rect49, _rect50, _rect51, _rect52, _path, _path2, _polygon6, _path3, _polygon7, _rect53, _rect54, _rect55, _rect56, _rect57, _path4, _circle2, _circle3, _circle4, _circle5, _polygon8, _polygon9, _rect58, _rect59, _path5, _path6, _polygon10, _polygon11, _polygon12, _path7, _path8, _path9, _rect60, _path10, _circle6, _circle7, _circle8, _circle9, _polygon13, _polygon14, _rect61, _rect62, _path11, _path12, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 888.51619,
    height: 743.97585,
    viewBox: "0 0 888.51619 743.97585",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "order_a_car") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 249.50886,
    cy: 102.71654,
    r: 65.61691,
    fill: "#ff6584"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "632.671 121.848 553.963 121.848 553.963 50.296 632.671 121.848",
    fill: "#3f3d56"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 245.91639,
    y: 119.50556,
    width: 395.95113,
    height: 547.02946,
    fill: "#e6e6e6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 285.41949,
    y: 157.86021,
    width: 46.58249,
    height: 98.15595,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 357.47209,
    y: 157.86021,
    width: 46.58249,
    height: 98.15595,
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 279.28006,
    y: 296.98317,
    width: 46.58249,
    height: 98.15595,
    fill: "#fff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 357.47209,
    y: 296.98317,
    width: 46.58249,
    height: 98.15595,
    fill: "#fff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 279.28006,
    y: 425.7095,
    width: 46.58249,
    height: 98.15595,
    fill: "#fff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 355.71796,
    y: 423.95538,
    width: 46.58249,
    height: 98.15595,
    fill: "#fff"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 423.42344,
    y: 568.59889,
    width: 46.58249,
    height: 98.15595,
    fill: "#ccc"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 493.80176,
    y: 423.95538,
    width: 46.58249,
    height: 98.15595,
    fill: "#fff"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 571.99379,
    y: 423.95538,
    width: 46.58249,
    height: 98.15595,
    fill: "#fff"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 495.55588,
    y: 295.94401,
    width: 46.58249,
    height: 98.15595,
    fill: "#fff"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 573.74791,
    y: 295.94401,
    width: 46.58249,
    height: 98.15595,
    fill: "#fff"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 495.55588,
    y: 157.86021,
    width: 46.58249,
    height: 98.15595,
    fill: "#fff"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 573.74791,
    y: 157.86021,
    width: 46.58249,
    height: 98.15595,
    fill: "#fff"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 245.91639,
    y: 245.94374,
    width: 395.95113,
    height: 14.97294,
    fill: "#3f3d56"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 245.91639,
    y: 362.39995,
    width: 395.95113,
    height: 8.3183,
    fill: "#3f3d56"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 245.91639,
    y: 335.78139,
    width: 395.95113,
    height: 8.3183,
    fill: "#3f3d56"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 403.32195,
    y: 571.00935,
    width: 66.54641,
    height: 8.3183,
    transform: "translate(856.02176 60.56127) rotate(90)",
    fill: "#3f3d56"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 449.90444,
    y: 571.00935,
    width: 66.54641,
    height: 8.3183,
    transform: "translate(902.60424 13.97879) rotate(90)",
    fill: "#3f3d56"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 496.48693,
    y: 571.00935,
    width: 66.54641,
    height: 8.3183,
    transform: "translate(949.18673 -32.6037) rotate(90)",
    fill: "#3f3d56"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 543.06941,
    y: 571.00935,
    width: 66.54641,
    height: 8.3183,
    transform: "translate(995.76921 -79.18619) rotate(90)",
    fill: "#3f3d56"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 589.6519,
    y: 571.00935,
    width: 66.54641,
    height: 8.3183,
    transform: "translate(1042.3517 -125.76867) rotate(90)",
    fill: "#3f3d56"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 636.23438,
    y: 571.00935,
    width: 66.54641,
    height: 8.3183,
    transform: "translate(1088.93418 -172.35116) rotate(90)",
    fill: "#3f3d56"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 682.81687,
    y: 571.00935,
    width: 66.54641,
    height: 8.3183,
    transform: "translate(1135.51667 -218.93364) rotate(90)",
    fill: "#3f3d56"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 729.39935,
    y: 571.00935,
    width: 66.54641,
    height: 8.3183,
    transform: "translate(1182.09916 -265.51613) rotate(90)",
    fill: "#3f3d56"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 404.15378,
    y: 444.57118,
    width: 66.54641,
    height: 8.3183,
    transform: "translate(730.41541 -66.70873) rotate(90)",
    fill: "#3f3d56"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 450.73627,
    y: 444.57118,
    width: 66.54641,
    height: 8.3183,
    transform: "translate(776.9979 -113.29122) rotate(90)",
    fill: "#3f3d56"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 497.31876,
    y: 444.57118,
    width: 66.54641,
    height: 8.3183,
    transform: "translate(823.58038 -159.87371) rotate(90)",
    fill: "#3f3d56"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 543.90124,
    y: 444.57118,
    width: 66.54641,
    height: 8.3183,
    transform: "translate(870.16287 -206.45619) rotate(90)",
    fill: "#3f3d56"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 590.48373,
    y: 444.57118,
    width: 66.54641,
    height: 8.3183,
    transform: "translate(916.74535 -253.03868) rotate(90)",
    fill: "#3f3d56"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 637.06621,
    y: 444.57118,
    width: 66.54641,
    height: 8.3183,
    transform: "translate(963.32784 -299.62116) rotate(90)",
    fill: "#3f3d56"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 683.6487,
    y: 444.57118,
    width: 66.54641,
    height: 8.3183,
    transform: "translate(1009.91032 -346.20365) rotate(90)",
    fill: "#3f3d56"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 730.23118,
    y: 444.57118,
    width: 66.54641,
    height: 8.3183,
    transform: "translate(1056.49281 -392.78614) rotate(90)",
    fill: "#3f3d56"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 404.15378,
    y: 296.50542,
    width: 66.54641,
    height: 8.3183,
    transform: "translate(582.34965 -214.77449) rotate(90)",
    fill: "#3f3d56"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 450.73627,
    y: 296.50542,
    width: 66.54641,
    height: 8.3183,
    transform: "translate(628.93214 -261.35698) rotate(90)",
    fill: "#3f3d56"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 497.31876,
    y: 296.50542,
    width: 66.54641,
    height: 8.3183,
    transform: "translate(675.51462 -307.93946) rotate(90)",
    fill: "#3f3d56"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 543.90124,
    y: 296.50542,
    width: 66.54641,
    height: 8.3183,
    transform: "translate(722.09711 -354.52195) rotate(90)",
    fill: "#3f3d56"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 590.48373,
    y: 296.50542,
    width: 66.54641,
    height: 8.3183,
    transform: "translate(768.67959 -401.10444) rotate(90)",
    fill: "#3f3d56"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 637.06621,
    y: 296.50542,
    width: 66.54641,
    height: 8.3183,
    transform: "translate(815.26208 -447.68692) rotate(90)",
    fill: "#3f3d56"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 683.6487,
    y: 296.50542,
    width: 66.54641,
    height: 8.3183,
    transform: "translate(861.84457 -494.26941) rotate(90)",
    fill: "#3f3d56"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 730.23118,
    y: 296.50542,
    width: 66.54641,
    height: 8.3183,
    transform: "translate(908.42705 -540.85189) rotate(90)",
    fill: "#3f3d56"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 245.91639,
    y: 212.67053,
    width: 395.95113,
    height: 8.3183,
    fill: "#3f3d56"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 245.91639,
    y: 186.05197,
    width: 395.95113,
    height: 8.3183,
    fill: "#3f3d56"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 245.91639,
    y: 390.68218,
    width: 395.95113,
    height: 14.97294,
    fill: "#3f3d56"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 227.69606,
    y: 113.35052,
    width: 432.39178,
    height: 22.31203,
    fill: "#3f3d56"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "332.09 589.824 332.09 568.599 306.62 568.599 306.62 589.824 329.967 589.824 332.09 589.824",
    fill: "#fff"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "329.967 606.803 306.62 606.803 306.62 628.028 332.09 628.028 332.09 606.803 329.967 606.803",
    fill: "#fff"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 349.06967,
    y: 568.59889,
    width: 25.46968,
    height: 21.22474,
    fill: "#fff"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 349.06967,
    y: 606.80342,
    width: 25.46968,
    height: 21.22474,
    fill: "#fff"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "539.823 589.824 539.823 568.599 514.353 568.599 514.353 589.824 537.7 589.824 539.823 589.824",
    fill: "#fff"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "537.7 606.803 514.353 606.803 514.353 628.028 539.823 628.028 539.823 606.803 537.7 606.803",
    fill: "#fff"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 556.80238,
    y: 568.59889,
    width: 25.46968,
    height: 21.22474,
    fill: "#fff"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 556.80238,
    y: 606.80342,
    width: 25.46968,
    height: 21.22474,
    fill: "#fff"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 245.91639,
    y: 517.12035,
    width: 395.95113,
    height: 14.97294,
    fill: "#3f3d56"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 245.91639,
    y: 490.50179,
    width: 395.95113,
    height: 8.3183,
    fill: "#3f3d56"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 245.91639,
    y: 463.88322,
    width: 395.95113,
    height: 8.3183,
    fill: "#3f3d56"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M521.52948,737.41713q.00127-.69458-.01885-1.38245c-.35566-12.26384-12.52137-15.58992-19.04334-9.78436a11.31359,11.31359,0,0,0-14.83619,0c-6.54992-5.71407-18.47313-2.62465-18.8668,9.5q-.02232.68735-.02366,1.382a71.13,71.13,0,0,0,.46808,7.62981h51.8591A70.394,70.394,0,0,0,521.52948,737.41713Z",
    transform: "translate(-155.74191 -78.01207)",
    fill: "#5b6d49"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M727.63915,737.41713q.00129-.69458-.01884-1.38245c-.35567-12.26384-12.52137-15.58992-19.04335-9.78436a11.31359,11.31359,0,0,0-14.83619,0c-6.54991-5.71407-18.47312-2.62465-18.8668,9.5q-.02232.68735-.02366,1.382a71.13262,71.13262,0,0,0,.46808,7.62981h51.8591A70.394,70.394,0,0,0,727.63915,737.41713Z",
    transform: "translate(-155.74191 -78.01207)",
    fill: "#5b6d49"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "856.314 667.579 848.294 667.579 850.967 510.911 853.641 510.911 856.314 667.579",
    fill: "#e6e6e6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1018.73907,490.28874l12.94645-20.00813a299.96218,299.96218,0,0,0-13.28225-31.09245l-8.37159,6.76162,6.62865-10.24416c-6.31716-12.43509-11.28787-20.26986-11.28787-20.26986s-25.96452,40.91589-34.63911,84.23652l16.61329,25.67516L968.955,510.49259a121.35739,121.35739,0,0,0-1.009,15.21765c0,51.30608,16.75638,92.89789,37.42648,92.89789s37.42649-41.59181,37.42649-92.89789c0-15.9054-3.59831-32.54594-8.562-47.939Z",
    transform: "translate(-155.74191 -78.01207)",
    fill: "#e6e6e6"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "828.074 448.447 656.97 448.447 656.97 574.433 657.074 574.433 657.074 599.516 682.157 574.433 828.074 574.433 828.074 448.447",
    fill: "#5b6d49"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 459.89195,
    y: 717.51236,
    width: 151.80315,
    height: 6,
    fill: "#e6e6e6"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 735.89195,
    y: 717.51236,
    width: 152.62424,
    height: 6,
    fill: "#e6e6e6"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 183.89195,
    y: 717.51236,
    width: 152,
    height: 6,
    fill: "#e6e6e6"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    y: 666.61904,
    width: 887.89195,
    height: 1.67281,
    fill: "#3f3d56"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 852.13582,
    y: 770.69096,
    width: 17.87573,
    height: 2.83742,
    transform: "translate(1565.99262 1466.66741) rotate(-179.96937)",
    fill: "#3f3d56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M722.89188,771.32645l3.68818.8532,140.16838.07492,1.26042-2.93666a29.642,29.642,0,0,0,2.17924-16.028c-.60369-4.05581-2.11645-8.08584-5.55233-9.83623L858.41559,702.024l-77.548-.13878-30.003,24.19934s-14.15287-.25442-21.84173,9.31775a22.4677,22.4677,0,0,0-4.69972,12.3743l-.30344,4.97952Z",
    transform: "translate(-155.74191 -78.01207)",
    fill: "#5b6d49"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 597.93632,
    cy: 692.62148,
    r: 17.30824,
    fill: "#3f3d56"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 597.93632,
    cy: 692.62148,
    r: 9.1096,
    fill: "#ccc"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 683.34255,
    cy: 692.66713,
    r: 17.30824,
    fill: "#3f3d56"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 683.34255,
    cy: 692.66713,
    r: 9.1096,
    fill: "#ccc"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "607.043 645.244 648.913 645.262 654.024 645.262 662.653 645.268 662.653 644.638 662.659 637.051 662.665 628.53 656.925 628.53 651.813 628.524 642.76 628.518 637.649 628.518 627.197 628.512 607.043 645.244",
    fill: "#fff"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "669.466 645.274 691.594 645.286 691.6 640.944 691.6 633.356 691.606 628.548 688.366 628.548 683.255 628.542 669.472 628.536 669.466 645.274",
    fill: "#fff"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 815.55112,
    y: 735.76715,
    width: 2.83742,
    height: 5.39109,
    transform: "matrix(-1, -0.00053, 0.00053, -1, 1477.8029, 1399.3499)",
    fill: "#3f3d56"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 770.01536,
    y: 726.80495,
    width: 2.83742,
    height: 5.39109,
    transform: "matrix(-0.00053, 1, -1, -0.00053, 1345.6049, -119.55561)",
    fill: "#3f3d56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M765.90437,717.46856h.31212a5.9302,5.9302,0,0,1,5.9302,5.9302v0a5.9302,5.9302,0,0,1-5.9302,5.9302h-.31212a0,0,0,0,1,0,0v-11.8604A0,0,0,0,1,765.90437,717.46856Z",
    transform: "translate(1381.92237 1369.1964) rotate(-179.96937)",
    fill: "#3f3d56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M724.01973,752.75617a9.16614,9.16614,0,0,0,5.00316-17.35382,22.4677,22.4677,0,0,0-4.69972,12.3743Z",
    transform: "translate(-155.74191 -78.01207)",
    fill: "#3f3d56"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "651.813 628.524 662.653 644.638 662.659 637.051 656.925 628.53 651.813 628.524",
    fill: "#f2f2f2"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "683.255 628.542 691.6 640.944 691.6 633.356 688.366 628.548 683.255 628.542",
    fill: "#f2f2f2"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "637.649 628.518 648.913 645.262 654.024 645.262 642.76 628.518 637.649 628.518",
    fill: "#f2f2f2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M566.13894,79.06022l-.11563.063a8.551,8.551,0,0,1-8.15337.0286q-.10842-.05847-.21556-.11547a8.59223,8.59223,0,0,0-8.14418.02812l-.1079.05875a8.551,8.551,0,0,1-8.15337.0286q-.11256-.0607-.22374-.11983a8.54327,8.54327,0,0,0-8.06465-.01427c-3.7924,2.04234-8.91927,5.53425-8.89669,9.4778a4.58691,4.58691,0,0,0,.02648.4668c.441,4.09539,13.79876,5.13891,21.1368,3.20886a37.35786,37.35786,0,0,0,16.621,0c7.30669,1.96094,20.93614.83749,21.33452-3.30489a4.58819,4.58819,0,0,0,.02121-.467c-.02253-3.94569-5.19474-7.401-9.011-9.41459A8.53471,8.53471,0,0,0,566.13894,79.06022Z",
    transform: "translate(-155.74191 -78.01207)",
    fill: "#e6e6e6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M934.13894,214.27615l-.11563.063a8.551,8.551,0,0,1-8.15337.0286q-.10842-.05847-.21556-.11547a8.59226,8.59226,0,0,0-8.14418.02811l-.1079.05876a8.551,8.551,0,0,1-8.15337.0286q-.11256-.06071-.22374-.11983a8.54324,8.54324,0,0,0-8.06465-.01427c-3.7924,2.04233-8.91927,5.53425-8.89669,9.47779a4.58694,4.58694,0,0,0,.02648.46681c.441,4.09539,13.79876,5.13891,21.1368,3.20885a37.35756,37.35756,0,0,0,16.621,0c7.30669,1.961,20.93614.8375,21.33452-3.30488a4.58839,4.58839,0,0,0,.02121-.467c-.02253-3.94568-5.19474-7.401-9.011-9.41459A8.53474,8.53474,0,0,0,934.13894,214.27615Z",
    transform: "translate(-155.74191 -78.01207)",
    fill: "#e6e6e6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M289.709,221.82425l-.11563.06294a8.551,8.551,0,0,1-8.15336.02861q-.10842-.05848-.21557-.11548a8.59227,8.59227,0,0,0-8.14417.02812l-.10791.05875a8.551,8.551,0,0,1-8.15336.02861q-.11256-.06072-.22375-.11983a8.54322,8.54322,0,0,0-8.06464-.01428c-3.7924,2.04234-8.91927,5.53425-8.8967,9.4778a4.58658,4.58658,0,0,0,.02648.4668c.441,4.09539,13.79877,5.13891,21.1368,3.20886a37.35771,37.35771,0,0,0,16.621,0c7.30669,1.96094,20.93615.8375,21.33453-3.30488a4.5914,4.5914,0,0,0,.0212-.467c-.02253-3.94569-5.19473-7.401-9.01094-9.41459A8.5347,8.5347,0,0,0,289.709,221.82425Z",
    transform: "translate(-155.74191 -78.01207)",
    fill: "#e6e6e6"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 92.27846,
    y: 726.67936,
    width: 17.87573,
    height: 2.83742,
    fill: "#3f3d56"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M395.14,805.32693l-3.68818.8532-140.16837.07492-1.26043-2.93666a29.642,29.642,0,0,1-2.17924-16.028c.60369-4.05581,2.11645-8.08584,5.55233-9.83624l6.22018-41.42961,77.548-.13878,30.003,24.19934s14.15287-.25442,21.84173,9.31775a22.4677,22.4677,0,0,1,4.69972,12.3743l.30344,4.97952Z",
    transform: "translate(-155.74191 -78.01207)",
    fill: "#5b6d49"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 208.61178,
    cy: 726.62196,
    r: 17.30824,
    fill: "#3f3d56"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 208.61178,
    cy: 726.62196,
    r: 9.1096,
    fill: "#ccc"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.20554,
    cy: 726.66761,
    r: 17.30824,
    fill: "#3f3d56"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.20554,
    cy: 726.66761,
    r: 9.1096,
    fill: "#ccc"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "199.505 679.244 157.635 679.263 152.524 679.263 143.895 679.269 143.895 678.639 143.889 671.051 143.883 662.531 149.624 662.531 154.735 662.524 163.788 662.518 168.899 662.518 179.351 662.512 199.505 679.244",
    fill: "#fff"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "137.082 679.275 114.954 679.287 114.948 674.945 114.948 667.357 114.942 662.549 118.182 662.549 123.293 662.543 137.076 662.537 137.082 679.275",
    fill: "#fff"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 143.90147,
    y: 691.75556,
    width: 2.83742,
    height: 5.39109,
    fill: "#3f3d56"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 345.17913,
    y: 760.80543,
    width: 2.83742,
    height: 5.39109,
    transform: "translate(954.17153 338.483) rotate(89.96937)",
    fill: "#3f3d56"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M190.14332,673.457h.31212a5.93019,5.93019,0,0,1,5.93019,5.93019v0a5.9302,5.9302,0,0,1-5.9302,5.9302h-.31212a0,0,0,0,1,0,0V673.457A0,0,0,0,1,190.14332,673.457Z",
    fill: "#3f3d56"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M394.01218,786.75665a9.16614,9.16614,0,0,1-5.00316-17.35382,22.4677,22.4677,0,0,1,4.69972,12.3743Z",
    transform: "translate(-155.74191 -78.01207)",
    fill: "#3f3d56"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "154.735 662.524 143.895 678.639 143.889 671.051 149.624 662.531 154.735 662.524",
    fill: "#f2f2f2"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "123.293 662.543 114.948 674.945 114.948 667.357 118.182 662.549 123.293 662.543",
    fill: "#f2f2f2"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    points: "168.899 662.518 157.635 679.263 152.524 679.263 163.788 662.518 168.899 662.518",
    fill: "#f2f2f2"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    points: "736.528 538.291 714.678 510.199 727.384 500.316 737.729 513.617 772.679 476.725 784.366 487.797 736.528 538.291",
    fill: "#fff"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    points: "6.34 480.325 177.444 480.325 177.444 606.311 177.34 606.311 177.34 631.394 152.257 606.311 6.34 606.311 6.34 480.325",
    fill: "#5b6d49"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    points: "87.042 573.169 65.192 545.077 77.899 535.193 88.244 548.495 123.193 511.603 134.88 522.674 87.042 573.169",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicle);
export default __webpack_public_path__ + "static/media/vehicle.a5ffc727f9a866711b07b3439db50ed1.svg";
export { ForwardRef as ReactComponent };